<ion-content>
  @if (gameInfo$ | async; as gameInfo) {
    <ion-grid>
      <ion-row>
        <ion-col size="12" class="upper-col">
          <div class="upper-col__content">
            <div class="upper-coverimage-overlay"></div>
            <ion-buttons slot="start" (click)="goBack()">
              <img src="assets/images/page-back-icon-white.png" class="back-ic" />
            </ion-buttons>
            <img alt="game-imge" class="game-cover-image" src="{{ gameInfo?.game_popup_image_url }}" />
          </div>
        </ion-col>
        <ion-col size="12" class="bottom-col">
          <div class="bottom-col__content">
            <h1 class="total-price">
              <!--           {{
              ("game_details_page.total_prizes" | translate) ? ("game_details_page.total_prizes" | translate)
              : "Total prizes"
              }}:
              {{ gameInfo && gameInfo?.country_code_data ? gameInfo?.country_code_data?.[preferredCurrency=='CAD'? 1 :
              preferredCurrency=='EUR' ? 353 : 44].total_prize : "" }} -->
              {{gameTotalPrize}}
            </h1>
            <h2 class="top-price">
              @if (gameTopPrize) {
                <span>
                  {{
                  ("game_details_page.top_prize" | translate) ? ("game_details_page.top_prize" | translate) : "Top Prize"
                  }}
                  : {{ gameTopPrize }}
                </span>
              }
            </h2>
            <h6 class="bottom-col__content__header">
              @if (gameInfo?.game_price > 0) {
                <span>{{flashSaleEnabled ? salesCost : gameInfo?.game_price}}
                  {{
                  ("game_details_page.points_per_play" | translate)
                  ? ("game_details_page.points_per_play" | translate)
                  : "points per play"
                }}</span>
              }
              @if (gameInfo?.game_price === 0) {
                <span>
                  {{
                  ("game_details_page.free_play" | translate)
                  ? ("game_details_page.free_play" | translate)
                  : "Free play"
                }}</span>
              }
            </h6>
            <h6 class="bottom-col__content__subheader">
              {{ gameInfo?.game_popup_details }}
            </h6>
            @if (gameInfo?.learn_more_rules) {
              <h6 class="bottom-col__content__subheaderRules">
                {{ gameInfo?.learn_more_rules }}
              </h6>
            }
            @if (gameInfo?.next_level_details) {
              <div class="bottom-col__content__next-level">
                <h4>
                  {{
                  ("game_details_page.next_level" | translate)
                  ? ("game_details_page.next_level" | translate)
                  : "Next level"
                  }}
                  {{ gameInfo?.next_level_details?.next_level }} •
                  @if (gameInfo?.game_type_id != 2) {
                    <span
                      >{{
                      ("game_details_page.chapter" | translate) ? ("game_details_page.chapter" | translate) : "Chapter"
                      }}
                      {{ gameInfo?.next_level_details?.current_chapter }}</span
                      >
                    }
                  </h4>
                  @if (gameInfo?.next_level_details?.target_details) {
                    <ion-row
                      class="bottom-col__content__next-level__content"
                      >
                      @for (key of gameInfo?.next_level_details?.target_details | keys; track key) {
                        <ion-col>
                          <h6>{{ key }}</h6>
                          <h4>{{ gameInfo?.next_level_details?.target_details[key] }}</h4>
                        </ion-col>
                      }
                    </ion-row>
                  }
                </div>
              }
              @if (inProgressChapters?.length) {
                <div class="bottom-col__content__game-progress">
                  <h4>
                    {{
                    ("game_details_page.your_progress" | translate)
                    ? ("game_details_page.your_progress" | translate)
                    : "Your progress"
                    }}
                  </h4>
                  @for (game of inProgressChapters; track game; let i = $index) {
                    <ion-row class="progress-wrapper">
                      <ion-col class="progess-img-wrap" size="3.3">
                        <img
                          alt="game-image"
                          class="progess-img"
                          [class.deactive]="!game.level_position"
                          src="{{ game.chapter_image }}"
                          />
                        </ion-col>
                        <ion-col class="progress-content-wrapper" size="8.7">
                          <ion-row class="progress-upper-content">
                            <ion-col class="progress-upper-content-wrap">
                              <p class="price-amt">
                                {{ ("game_details_page.prize" | translate) ? ("game_details_page.prize" | translate) : "Prize" }}
                                {{ chapterPrize?.[game?.chapter_id]?.chapter_prize?.int_prize }}
                              </p>
                              <p class="chapter">
                                {{
                                ("game_details_page.chapter" | translate)
                                ? ("game_details_page.chapter" | translate)
                                : "Chapter"
                                }}
                                {{ game?.chapter_id }}
                              </p></ion-col
                              >
                              <ion-col class="progress-status-wrap">
                                <p [ngClass]="{ 'playing-status': game.chapter_status, 'locked-status': !game.chapter_status }">
                                  {{ game?.chapter_status }}
                                </p>
                              </ion-col>
                            </ion-row>
                            <ion-row class="progress-bar-wrap">
                              <ion-progress-bar color="secondary" class="progress-bar" value="{{ game?.chapter_progress / 100 }}">
                              </ion-progress-bar>
                            </ion-row>
                          </ion-col>
                        </ion-row>
                      }
                    </div>
                  }
                  @if (completedChapters?.length) {
                    <div class="bottom-col__content__completed-chapters">
                      <h4>
                        {{
                        ("game_details_page.completed_chapters" | translate)
                        ? ("game_details_page.completed_chapters" | translate)
                        : "Completed chapters"
                        }}
                      </h4>
                      @for (game of completedChapters; track game; let i = $index) {
                        <ion-row class="progress-wrapper">
                          <ion-col class="progess-img-wrap" size="3.3">
                            <img class="progess-img" src="{{ game?.chapter_image }}" />
                          </ion-col>
                          <ion-col class="progress-content-wrapper" size="8.7">
                            <ion-row class="progress-upper-content">
                              <ion-col class="progress-upper-content-wrap">
                                {{ ("game_details_page.prize" | translate) ? ("game_details_page.prize" | translate) : "Prize"
                                }}{{ " " + chapterPrize?.[game?.chapter_id]?.chapter_prize?.int_prize }}
                                <p class="chapter">
                                  {{
                                  ("game_details_page.chapter" | translate)
                                  ? ("game_details_page.chapter" | translate)
                                  : "Chapter"
                                  }}
                                  {{ game?.chapter_id }}
                                </p>
                              </ion-col>
                              <ion-col class="progress-status-wrap">
                                <img alt="game-win" class="game-win-ic" src="../../assets/images/win-icon.svg" />
                              </ion-col>
                            </ion-row>
                          </ion-col>
                        </ion-row>
                      }
                    </div>
                  }
                  @if (gameInfo?.prize_details && (gameInfo?.prize_details | keyvalue).length > 0) {
                    <div class="bottom-col__content__prize-list">
                      <h4 class="bottom-col__content__prize-list__header">
                        {{
                        ("game_details_page.prize_list" | translate)
                        ? ("game_details_page.prize_list" | translate)
                        : "Prize list"
                        }}
                      </h4>
                      @for (lootBox of gameInfo?.prize_details | keyvalue: compareFn; track lootBox) {
                        <div class="bottom-col__content__prize-list__list">
                          @if (gameInfo?.game_id != hidePrizeHeading && (gameInfo?.prize_details | keyvalue).length > 1) {
                            <h6 class="price-win bottom-col__content__prize-list__header">{{lootBox.key}}</h6>
                          }
                          <ion-row class="bottom-col__content__prize-list__list__row">
                            <ion-col size="10" class="bottom-col__content__prize-list__list__row__detail">
                              <h6>1</h6>
                              <h4 class="price-win bottom-col__content__prize-list__header fw-500">
                                {{ lootBox.value[0]?.type === "game" ? lootBox.value[0]?.award_name : lootBox.value[0]?.int_award_name[languageCode] }}
                              </h4>
                            </ion-col>
                            <ion-col size="2" class="bottom-col__content__prize-list__list__row__winner">
                              <img alt="game-winner" src="../../assets/images/win-icon.svg" />
                            </ion-col>
                          </ion-row>
                        @if(lootBox?.value?.length) {
                          @for (item of lootBox?.value; track item; let i = $index) {
                            <div class="bottom-col__content__prize-list__list"
                              >
                              @if (i % 2 == 1) {
                                <ion-row class="bottom-col__content__prize-list__list__row">
                                  @if (i < lootBox.value.length) {
                                    <ion-col size="6.5"
                                      class="bottom-col__content__prize-list__list__row__detail">
                                      <h6 [ngClass]="i > 8 ? 'prize-digit-margin' : ''">{{ i + 1 }}</h6>
                                      <h4>
                                        {{ lootBox.value[i]?.type === "game" ? lootBox.value[i]?.award_name : lootBox.value[i]?.int_award_name[languageCode] }}
                                      </h4>
                                    </ion-col>
                                  }
                                  @if (i + 1 < lootBox.value.length) {
                                    <ion-col size="5.5"
                                      class="bottom-col__content__prize-list__list__row__detail">
                                      <h6 [ngClass]="i > 8 ? 'prize-digit-margin' : ''">{{ i + 2 }}</h6>
                                      <h4>
                                        {{ lootBox.value[i+1]?.type === "game" ? lootBox.value[i+1]?.award_name : lootBox.value[i+1]?.int_award_name[languageCode] }}
                                      </h4>
                                    </ion-col>
                                  }
                                </ion-row>
                              }
                            </div>
                          }
                        }
                        </div>
                      }
                    </div>
                  }
                  @if (gameInfo?.screen_shot && gameInfo?.screen_shot?.length) {
                    <div class="bottom-col__content__screenshots">
                      <h4>
                        {{
                        ("game_details_page.screenshots" | translate)
                        ? ("game_details_page.screenshots" | translate)
                        : "Screenshots"
                        }}
                      </h4>
                      <ion-row class="bottom-col__content__screenshots__row">
                        @for (screenshot of gameInfo?.screen_shot; track screenshot) {
                          <ion-col class="screenshot-img-col">
                            @if (screenshot) {
                              <img ionImgViewer alt="game-image" class="screenshot-img" src="{{ screenshot }}" />
                            }
                            @if (!screenshot || screenshot == 'unknown') {
                              <img
                                ionImgViewer
                                alt="game-image"
                                class="screenshot-img"
                                src="assets/images/broken_image.png"
                                />
                            }
                          </ion-col>
                        }
                      </ion-row>
                    </div>
                  }
                  <div class="button-wrapper">
                    <ion-button expand="block" shape="round" class="play-now" [disabled]="isButtonDisabled" (click)="playGame(gameInfo); startSpinner()">
                      @if (!spinnerAnimation && proceed) {
                        <span>{{
                          ("game_details_page.play_now" | translate) ? ("game_details_page.play_now" | translate) : "Play now"
                        }}</span>
                      }
                      @if (spinnerAnimation && proceed) {
                        <div class="spinners">
                          <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="30">
                          </mat-progress-spinner>
                        </div>
                      }
                      @if (!proceed && !spinnerAnimation) {
                        <mat-icon [@bounceIn] class="tick-mark">{{
                          ("game_details_page.done_btn" | translate) ? ("game_details_page.done_btn" | translate) : "done"
                        }}</mat-icon>
                      }
                    </ion-button>
                  </div>
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
        } @else {
          <app-in-progress-animation></app-in-progress-animation>
        }
      </ion-content>
